export default "__VITE_ASSET__CUyxA19k__"